import { render, staticRenderFns } from "./LoginCallback.vue?vue&type=template&id=ef9e38ce&"
import script from "./LoginCallback.vue?vue&type=script&lang=ts&"
export * from "./LoginCallback.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports